import React from 'react';
import styled from 'styled-components';
import { galleryData } from '../data/GalleryData';

const Section = styled.section`
width: 100%;
height: 100%;
padding: 4rem 0rem;
background-image: radial-gradient( circle 1158px at 6.4% 48.8%,  rgba(195,241,245,1) 0%, rgba(255,255,255,1) 90.2% );
@media screen and (device-width : 375px){
    margin-right: 30px;
} 
@media screen and (device-width : 360px){
    margin-right: 30px;
} 
`;
const Container = styled.section`
    padding: 3rem;
    display: grid;
    grid-template-colums: 1fr 1fr;
    grid-template-rows: 100px;
    @media screen and (max-width: 768px){
        grid-template-columns: 1fr;
    }
    @media screen and (device-width : 375px){
        display: block;
    } 
    @media screen and (device-width : 360px){
        display: block;
    } 
    @media screen and (max-width : 500px){
        display: block;
    } 
`;
const Intro = styled.section`
    h1{
        color: #000d1a;
        display: flex;
        justify-content: center;
        font-size: 30px;
        margin-top: -30px;
    }
    p{
        color: #000d1a;
        display: flex;
        justify-content: center;
        font-size: 20px;
        font-style: italic;
        text-align: center;
        margin-top:20px;
        margin-bottom:20px;
    }
    @media screen and (max-width: 768px){
       h1{
           display: flex;
           justify-content:center;
       }
    }
    @media screen and (device-width : 375px){
        h1{
            margin-top: -65px;
        }
        p{
            text-align:left;
        }
    } 
    @media screen and (device-width : 360px){
        h1{
            margin-top: -65px;
        }
        p{
            text-align:left;
        }
    } 
    @media screen and (max-width : 500px){
        h1{
            margin-top: -65px;
        }
        p{
            text-align:left;
        }
    } 
`;
const Gallery = styled.section`
display:flex;
flex-direction: row;
justify-content: space-around;
flex-wrap: wrap;
@media screen and (max-width: 768px){
    margin-top: 50px;
}
`;

const ImgContainer = styled.div`
    width: 320px;
    height: 410px;
    margin-bottom: 20px;
    border: 2px solid #d3d3d3;
    overflow: hidden;
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform .5s ease;
    &:hover{
        transform: scale(1.2);
        cursor: pointer;
    }
    @media screen and (max-width: 768px){
        margin-bottom: 10px;
    }
`;

const Info = () => {
    return ( 
        <Section>
            <Container>
                <Intro>
                    <h1>Welcome to Tandoori Chiya Station & Cafe</h1>
                    <p>Good food and great vibes. Take a cup and forget about everything for a few minutes. </p>
                </Intro>
                <Gallery>
                    { galleryData.map((item, index) => (
                        <ImgContainer key={index}>
                        <Img src={item.image} alt="Gallery" key={index}/>
                        </ImgContainer>
                    ))}
                </Gallery>
            </Container>
        </Section>
     );
}
 
export default Info;